import { HashMap } from '../utils/HashMap'
import { Incentive, IncentivesState } from '../store/incentives/types'

export const timeBasedIncentivesSelector = (state: IncentivesState): HashMap<Incentive[]> => state.client
